import get from 'lodash/get';
import { pageTypes } from 'constants/pageTypes';
import { PAGE_DATA_ACTIONS } from 'actions/pageActionsV4';
import { SlotType } from '@rome/response/page/v4/SlotType';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
function extractMetadata(slots) {
    const output = {
        pincode: ''
    };
    const len = slots.length;
    for (let i = 0; i < len; i++) {
        const slot = slots[i];
        // proceed further only when the slot is an actual widget
        if (slot.slotType !== SlotType.WIDGET) {
            continue;
        }
        const widgetType = get(slot, 'widget.type');
        const widgetData = get(slot, 'widget.data');
        switch (widgetType) {
            /**
             * Extract out pincode
             */
            case WidgetTypeV4.COMPOSED_PINCODE_DELIVERY:
                output.pincode = get(widgetData, 'pincodeData.pincodeComponent.value.pincode');
                break;
            /**
             * Extract out pincode from new delivery widget (above maybe absent on new lifestyle layouts)
             */
            case WidgetTypeV4.DELIVERY_ADDRESS:
                if (output.pincode === '') {
                    output.pincode =
                        get(widgetData, 'addressInfo.address.pincode') || get(widgetData, 'pincodeInfo.pincode');
                }
                break;
            default:
                break;
        }
    }
    return output;
}
export default function (state = {}, action) {
    switch (action.type) {
        case PAGE_DATA_ACTIONS.SUCCESS:
            const slots = get(action, 'data.slots');
            if (!slots)
                return state;
            if (action.pageType && action.pageType === pageTypes.LookDetails) {
                return extractMetadata(slots);
            }
            return {};
        case PAGE_DATA_ACTIONS.REQUEST:
        case PAGE_DATA_ACTIONS.ERROR:
        case PAGE_DATA_ACTIONS.CLEAR:
            return {};
        default:
            return state;
    }
}
